import { render, staticRenderFns } from "./Filtro.vue?vue&type=template&id=2d70d45c&scoped=true&"
import script from "./Filtro.vue?vue&type=script&lang=js&"
export * from "./Filtro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d70d45c",
  null
  
)

export default component.exports